import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  topics: [],
  error: null,
  isFetchingTopics: false,
  isDeletingTopic: false,
};

export const topicSlice = createSlice({
  name: "topic",
  initialState,
  reducers: {
    getTopicStart: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    getTopicSuccess: (state, action) => {
      state.isLoading = false;
      state.topics = action.payload;
      state.error = null;
    },
    getTopicFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    clearTopic: (state, action) => {
      state.topics = [];
    },
    getAllTopicsStart: (state, action) => {
      state.isFetchingTopics = true;
      state.error = null;
    },
    getAllTopicsSuccess: (state, action) => {
      state.isFetchingTopics = false;
      state.topics = action.payload;
      state.error = null;
    },
    getAllTopicsFailure: (state, action) => {
      state.isFetchingTopics = false;
      state.error = action.payload;
    },
    deleteTopicStart: (state, action) => {
      state.isDeletingTopic = true;
    },
    deleteTopicSuccess: (state, action) => {
      state.isDeletingTopic = false;
    },
    deleteTopicFailure: (state, action) => {
      state.isDeletingTopic = false;
    },
  },
});

export const {
  getTopicStart,
  getTopicSuccess,
  getTopicFailure,
  clearTopic,
  getAllTopicsStart,
  getAllTopicsSuccess,
  getAllTopicsFailure,
  deleteTopicStart,
  deleteTopicSuccess,
  deleteTopicFailure,
} = topicSlice.actions;

const topicReducer = topicSlice.reducer;

export default topicReducer;
